var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 93 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59947 23.6453H15.6987V20.6645H4.59947V23.6453ZM4.59947 3.03295H15.6608V0.0155563H4.59947V3.03295ZM0 23.6453V0.0155563H3.83917V10.1946H15.0528V13.1757H3.83917V23.6453H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7821 23.6385H34.592V0H30.7821V23.6385ZM17.4661 15.183C17.4661 9.04038 21.1191 6.36636 25.9113 6.36636C27.4042 6.36636 28.8965 6.76393 29.9965 7.6673V11.4974C29.2108 9.94374 27.7969 9.221 26.0687 9.221C23.319 9.221 21.3157 11.1723 21.3157 15.183C21.3157 19.1941 23.319 21.1451 26.0687 21.1451C27.7969 21.1451 29.2108 20.4226 29.9965 18.9052V22.7351C28.936 23.6024 27.4042 24 25.9113 24C21.1191 24 17.4661 21.326 17.4661 15.183Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.7941 18.0011L57.5977 6.85715H61.4923L57.1695 23.2667L54.7941 18.0011ZM53.1517 23.6475L49.3422 16.3061L45.9929 22.7619L44.7469 18.1457L47.7455 12.4113H50.9778L56.5009 23.6475H53.1517ZM41.647 23.6475L37.2307 6.85715H41.125L45.3466 23.6475H41.647Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.6033 23.6453H67.4796V6.85714H63.6033V23.6453Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.109 23.6453V13.8402C82.109 10.9393 81.0596 9.21342 77.9513 9.21342C76.5135 9.21342 75.3866 9.72744 74.7261 10.5719V7.23008C75.6197 6.53249 77.0187 6.09177 78.4952 6.09177C83.6634 6.09177 85.8784 8.80936 85.8784 13.62V23.6453H82.109ZM70.1797 23.6453H73.9491V6.45917H70.1797V23.6453Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5098 23.6484C88.9007 23.6484 88.0193 22.5424 88.0193 21.2839C88.0193 19.9873 88.9007 18.9194 90.5098 18.9194C92.1572 18.9194 93 19.9873 93 21.2839C93 22.5424 92.1572 23.6484 90.5098 23.6484Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0DB876",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4962 5.08374C63.8871 5.08374 63.0057 3.97775 63.0057 2.71921C63.0057 1.42259 63.8871 0.354673 65.4962 0.354673C67.1436 0.354673 67.9864 1.42259 67.9864 2.71921C67.9864 3.97775 67.1436 5.08374 65.4962 5.08374Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11476ace9daf54cfe3ade38a7f879d4c.svg";
export { ForwardRef as ReactComponent };